//----- Component --------------------------------------------------------/
// Developer : Daiana Curcio
// Creation Date : 11/07/2025
// Version : 1
// Description : Gráfico de barras de stock por artículo y por sucursal.
//------Changes ----------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/
import { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  TextField,
  Button,
  Autocomplete,
} from "@mui/material";
import { UrlApi } from "../../../services/apirest";
import { Snackbar, Alert } from "@mui/material";
import Dialog_stock from "./Dialog_stock";

function Stock_actual(props) {
  const [datosGrafico, setDatosGrafico] = useState([]);
  const [busquedaRealizada, setBusquedaRealizada] = useState(false);
  //alertas
  const [openSnack, setOpenSnack] = useState(false);
  const [mensajeSnack, setMensajeSnack] = useState("");
  const [severitySnack, setSeveritySnack] = useState("error");
  //------------------ Dialog --------------------------//
  const [abrirDialog, setAbrirDialog] = useState(false);

  const handleOpenDialog = () => {
    setAbrirDialog(true);
  };

  const handleCloseDialog = () => {
    setAbrirDialog(false);
  };

  // // sucursales
  const [sucursalesDisponibles, setSucursalesDisponibles] = useState(
    props.sucursalesDisponibles
  );
  const [sucursalesSeleccionadas, setSucursalesSeleccionadas] = useState([]);

  // console.log("SUCURSALES", sucursalesDisponibles);
  // console.log("sucu selec", sucursalesSeleccionadas);

  const [familiaDisponible, setFamiliaDisponible] = useState([]);
  const [familiaSeleccionada, setFamiliaSeleccionada] = useState([]);

  const ObtenerFamilia = () => {
    fetch(UrlApi + "/estadisticas/familias")
      .then((res) => res.json())
      .then((data) => setFamiliaDisponible(data));
  };

  useEffect(() => {
    ObtenerFamilia();
  }, []);

  // console.log("FAMILIA", familiaDisponible);
  // console.log("FAMILIA SELEC", familiaSeleccionada);

  const [articulosDisponibles, setArticulosDisponibles] = useState([]);
  const [articulosSeleccionados, setArticulosSeleccionados] = useState([]);

  const ObtenerArticulos = (idsFamilia) => {
    if (!idsFamilia || idsFamilia.length === 0) {
      setArticulosDisponibles([]);
      setSucursalesDisponibles([]); //limpiar sucursales
      return;
    }

    const query = new URLSearchParams();
    query.append("id_familia", idsFamilia.join(","));

    fetch(`${UrlApi}/estadisticas/articulosPorFamilia?${query.toString()}`)
      .then((res) => res.json())
      .then((articulos) => {
        setArticulosDisponibles(articulos);

        // extraer ids de artículos
        const idsArticulos = articulos.map((a) => a.id_articulo);
        if (idsArticulos.length === 0) {
          setSucursalesDisponibles([]);
          return;
        }

        const querySuc = new URLSearchParams();
        querySuc.append("articulos", idsArticulos.join(","));

        //obtener solo sucursales que tengan stock de estos artículos
        fetch(
          `${UrlApi}/estadisticas/sucursalesConArticulos?${querySuc.toString()}`
        )
          .then((res) => res.json())
          .then((sucursales) => {
            setSucursalesDisponibles(sucursales);
            setSucursalesSeleccionadas(sucursales);
          })
          .catch((err) => {
            console.error("Error al obtener sucursales:", err);
            setSucursalesDisponibles([]);
          });
      })
      .catch((error) => {
        console.error("Error al obtener artículos:", error);
        setArticulosDisponibles([]);
        setSucursalesDisponibles([]);
      });
  };

  // console.log("ARTICULOS", articulosDisponibles);
  //  console.log("art selec", articulosSeleccionados);

  const mostrarError = (mensaje) => {
    setMensajeSnack(mensaje);
    setSeveritySnack("error");
    setOpenSnack(true);
  };

  function generarColores(cantidad) {
    const colores = [];
    for (let i = 0; i < cantidad; i++) {
      const hue = Math.floor((360 / cantidad) * i);
      colores.push(`hsl(${hue}, 70%, 50%)`); // saturación 70%, luminosidad 50%
    }
    return colores;
  }

  const handleBuscar = () => {
    if (familiaSeleccionada.length === 0) {
      mostrarError("Debe seleccionar al menos una familia.");
      return;
    }

    if (articulosSeleccionados.length === 0) {
      mostrarError("Debe seleccionar al menos un artículo.");
      return;
    }

    if (sucursalesSeleccionadas.length === 0) {
      mostrarError("Debe seleccionar al menos una sucursal.");
      return;
    }

    const idsFamilias = familiaSeleccionada.map((f) => f.id_familia);
    const idsArticulos = articulosSeleccionados.map((a) => a.id_articulo);
    const idsSucursales = sucursalesSeleccionadas.map((s) => s.id);

    const queryParams = new URLSearchParams();
    queryParams.append("familias", idsFamilias.join(","));
    queryParams.append("sucursales", idsSucursales.join(","));
    queryParams.append("articulos", idsArticulos.join(","));

    fetch(`${UrlApi}/estadisticas?${queryParams.toString()}`)
      .then((res) => res.json())
      .then((data) => {
        if (!Array.isArray(data)) {
          console.error("Respuesta inválida del servidor:", data);
          return;
        }

        const sucursalesUnicas = [
          ...new Set(data.map((item) => item.nombre_suc)),
        ];
        const coloresGenerados = generarColores(sucursalesUnicas.length);

        const agrupado = {};
        data.forEach((item) => {
          const claveArticulo = `${item.nombre_articulo} (${item.desc_art})`;
          if (!agrupado[claveArticulo]) {
            agrupado[claveArticulo] = { articulo: claveArticulo };
          }
          agrupado[claveArticulo][item.nombre_suc] = item.cantidad;
        });

        const dataset = Object.values(agrupado);
        if (dataset.length === 0) {
          mostrarError("No hay resultados encontrados.");
          return;
        }

        setDatosGrafico({
          dataset,
          sucursales: sucursalesUnicas,
          colores: coloresGenerados,
        });
        setBusquedaRealizada(true);
        setAbrirDialog(true);
      })
      .catch((error) => {
        console.error("Error al obtener datos de stock:", error);
      });
  };

  return (
    <div>
      <Grid container padding={3} spacing={2} alignItems="center">
        {" "}
        <Grid item xs={12}>
          <Typography
            align="center"
            style={{
              fontWeight: "bold",
              fontSize: 20,
              flexGrow: 1,
              textAlign: "center",
              marginBottom: 10,
            }}
          >
            Stock actual de insumos
          </Typography>
          {/* Familia */}
          <Box marginBottom={2}>
            <Autocomplete
              multiple
              size="small"
              options={familiaDisponible}
              value={familiaSeleccionada}
              onChange={(event, value) => {
                setFamiliaSeleccionada(value);
                setDatosGrafico([]);
                setBusquedaRealizada(false);
                setArticulosSeleccionados([]); // limpiar artículos seleccionados
                setSucursalesSeleccionadas([]); // limpiar sucursales seleccionadas
                const idsFamilia = value.map((f) => f.id_familia);
                ObtenerArticulos(idsFamilia);
              }}
              getOptionLabel={(option) => `${option.descripcion}`}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Familia de art."
                  placeholder="Tipee para buscar..."
                  //focused
                  sx={{
                    backgroundColor: "white",
                    width: "100%",
                    "& .MuiInputLabel-root": {
                      color: "black",
                    },
                    "& fieldset": {
                      borderColor: "black", // opcional: color del borde
                    },
                  }}
                />
              )}
            />
          </Box>
          {/* ARTICULOS */}
          <Box marginBottom={2}>
            <Autocomplete
              multiple
              size="small"
              options={articulosDisponibles}
              value={articulosSeleccionados}
              onChange={(event, value) => {
                setArticulosSeleccionados(value);
                setDatosGrafico([]);
                setBusquedaRealizada(false);
              }}
              getOptionLabel={(option) =>
                `${option.nombre}-${option.descripcion}`
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Artículo/s"
                  placeholder="Seleccione artículos..."
                  sx={{
                    backgroundColor: "white",
                    width: "100%",
                    "& .MuiInputLabel-root": { color: "black" },
                    "& fieldset": { borderColor: "black" },
                  }}
                />
              )}
            />
          </Box>
          {/* SUCURSAL */}
          <Box marginBottom={2}>
            <Autocomplete
              multiple
              size="small"
              options={sucursalesDisponibles}
              value={sucursalesSeleccionadas}
              onChange={(event, value) => {
                setSucursalesSeleccionadas(value);
                setDatosGrafico([]);
                setBusquedaRealizada(false);
              }}
              getOptionLabel={(option) => `${option.id} - ${option.nombre}`}
              filterSelectedOptions
              disableCloseOnSelect
              isOptionEqualToValue={(option, value) => option.id === value.id}
              getOptionDisabled={(option) => {
                // deshabilitar opciones que no están en sucursalesDisponibles
                return !sucursalesDisponibles.some((s) => s.id === option.id);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Sucursal/es"
                  placeholder="Tienen stock"
                  sx={{
                    backgroundColor: "white",
                    width: "100%",
                    "& .MuiInputLabel-root": {
                      color: "black",
                    },
                    "& fieldset": {
                      borderColor: "black",
                    },
                  }}
                />
              )}
            />
          </Box>
          {/* BOTÓN */}
          <Box display="flex" justifyContent="center" marginTop={2}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleBuscar}
              sx={{ height: 40 }}
            >
              Generar Gráfico
            </Button>
          </Box>
        </Grid>
      </Grid>
      {abrirDialog ? (
        <Dialog_stock
          abrirDialog={abrirDialog}
          onClose={handleCloseDialog}
          datosGrafico={datosGrafico}
        />
      ) : null}
      <Snackbar
        open={openSnack}
        autoHideDuration={4000}
        onClose={() => setOpenSnack(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity={severitySnack} onClose={() => setOpenSnack(false)}>
          {mensajeSnack}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default Stock_actual;
